<div class="ac-sticky-footer">
	<ng-content></ng-content>
</div>
